import React from "react";

export interface DiscountRenderProps {
    amount: {
        amount: number | string;
        currency: string;
    },
    discount: {
        name: string;
        value: number;
        percentage: boolean;
        totalDiscount: {
            amount: number;
            currency: string;
        };
    }
}

export function DiscountRender({ amount, discount }: DiscountRenderProps) {
    const unit = `${discount.value.toFixed(2)}${discount.percentage ? "%" : ""}`;
    const result = `${discount.totalDiscount.amount.toFixed(2)} ${discount.totalDiscount.currency}`;
    return <>{Number(amount.amount).toFixed(2)} x {unit} = {result}</>;
}
